import BaseResource from './BaseResource';

export default class UserResource extends BaseResource {
  static urlRoot = '/api/v2/user_permissions';

  id = '';

  permissions = {};

  pk() {
    return this.id;
  }

  static permissionsShape() {
    return {
      ...this.detailShape(),
      getFetchKey: () => '/api/v2/user_permissions',
      fetch: () => this.fetch('get', '/api/v2/user_permissions', {}, false)
    };
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/resources/UserResource.js